module.exports = __webpack_public_path__ + "static/media/NightsStayDark.a1f6db58.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/NightsStayDark.svg
// module id = 1154
// module chunks = 0